import { createSelector } from 'reselect'
import groupBy from 'lodash/groupBy'
import uniq from 'lodash/uniq'
import API from '../../../utils/http/api'
import * as taskTypesDuck from '../../../store/shared/taskTypesDuck'

// Action Types
const CREATE_SUCCESS = 'steppingblocks/adminTasksAssignment/CREATE_SUCCESS'
const FAILURE = 'steppingblocks/adminTasksAssignment/FAILURE'
const REQUEST = 'steppingblocks/adminTasksAssignment/REQUEST'
const RETRIEVE_SUCCESS = 'steppingblocks/adminTasksAssignment/RETRIEVE_SUCCESS'
const TOGGLE_MODAL = 'steppingblocks/adminTasksAssignment/TOGGLE_MODAL'

// Reducer
const initialState = {
  requestStarted: false,
  requestEnded: false,
  error: null,
  tasksAssigned: [],
  isModalOpen: false,
  activeTaskName: '',
  activeTaskType: '',
}

export default (_state = initialState, action) => {
  const { type, payload } = action
  switch(type) {
    case REQUEST:
      return {
        ..._state,
        requestStarted: true,
        requestEnded: false,
        error: null,
      }
    case CREATE_SUCCESS:
      return {
        ..._state,
        requestEnded: true,
      }
    case RETRIEVE_SUCCESS:
      return {
        ..._state,
        requestEnded: true,
        tasksAssigned: payload.results,
      }
    case FAILURE:
      return {
        ..._state,
        requestEnded: true,
        error: payload.error,
      }
    case TOGGLE_MODAL:
      return {
        ..._state,
        isModalOpen: !_state.isModalOpen,
        activeTaskName: payload.name,
        activeTaskType: payload.type,
      }
    default:
      return _state
  }
}

// Actions
export const toggleModal = (name = '', type = '') => ({ type: TOGGLE_MODAL, payload: { name, type } })

export const performRetrieveTasks = () => async dispatch => {
  dispatch({ type: REQUEST })
  try {
    const { results } = await API.get('/tasks/by_admin_subordinates')
    dispatch({
      type: RETRIEVE_SUCCESS,
      payload: {
        results,
      }
    })
  } catch (error) {
    dispatch({
      type: FAILURE,
      payload: { error: error.message },
    })
  }
}

export const performAssignTask = params => async dispatch => {
  dispatch({ type: REQUEST })
  try {
    await API.post('/tasks', params)
    dispatch({ type: CREATE_SUCCESS })
    return true
  } catch (error) {
    dispatch({
      type: FAILURE,
      payload: { error: error.message }
    })
  }
}


// Selectors
const adminTasksAssignment = state => state.adminTasksAssignment

// export const getActiveTask = createSelector(adminTasksAssignment, _ => ({ activeTaskName: _.activeTaskName, activeTaskType: _.activeTaskType }))

export const getModalState = createSelector(adminTasksAssignment, _ => _.isModalOpen)

export const getAssignedTasks = createSelector(adminTasksAssignment, _ => _.tasksAssigned)

export const getAssignedTaskTypes = createSelector(getAssignedTasks, _ => uniq(_.map(item => item.type)))

export const getAssignedTasksByType = createSelector(getAssignedTasks, _ => groupBy(_, 'type'))

export const getActiveTask = createSelector([adminTasksAssignment, taskTypesDuck.getFullTaskTypesByType], (base, types) => ({ activeTaskName: base.activeTaskName, activeTaskType: base.activeTaskType, taskType: types[base.activeTaskType] || {} }))



// WEBPACK FOOTER //
// ./src/routes/authenticated/AdminDashboard/adminTasksAssignmentDuck.js